import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-section-multi-accordion',
  templateUrl: './section-multi-accordion.component.html',
  styleUrls: ['./section-multi-accordion.component.css']
})
export class SectionMultiAccordionComponent implements OnInit {

  @Input() sectionInfo;
  questionsInfo;
  
  constructor() { }

  ngOnInit(): void {
    
  }

  getObjectsForAccordion(obj){
    let res = {
      title: obj.title,
      subtitle: obj.subtitle? obj.subtitle: null,
      array: obj.array,
      fieldForTitle: obj['fieldForTitle'],
      fieldForContent: obj['fieldForContent']
    }
    return res;
  }

}
